export const jobs = {
  description: "Planned and released production work.",
  newJob: "New job",
  searchHint: "Matches title or number.",
  emptyTitle: "No jobs match",
  emptyDescription: "Create a job or convert an accepted sales order.",
  notFound: "Job not found.",
  internalWork: "Internal work",
  column: {
    job: "Job",
    due: "Due",
  },
  filters: {
    allStatuses: "All statuses",
    anyDueDate: "Any due date",
    overdue: "Overdue",
    dueSoon: "Due within 7 days",
  },
  meta: {
    quantity: "Qty {quantity}",
    due: "Due {date}",
  },
  create: {
    description: "Scope, due date, and the ordered operations that make up the traveler.",
    button: "Create job",
    noneInternal: "None (internal job)",
  },
  header: {
    back: "Back to jobs",
  },
  action: {
    traveler: "Traveler",
    release: "Release",
    hold: "Hold",
    resume: "Resume",
    ready: "Ready",
    complete: "Complete",
  },
  toast: {
    hold: "Job placed on hold",
    released: "Job released",
    resumed: "Job resumed",
    ready: "Ready for delivery",
    completed: "Job completed",
    cancelled: "Job cancelled",
    created: "Job created",
  },
  holdModal: {
    title: "Place this job on hold?",
    hint: "Required for the history (minimum 3 characters).",
    confirm: "Place on hold",
  },
  cancelModal: {
    title: "Cancel this job?",
    keep: "Keep job",
    confirm: "Cancel job",
    reason: "Reason (optional)",
  },
  documents: {
    title: "Drawings & documents",
    empty: "No drawings attached.",
    download: "Download",
    attachLabel: "Attach drawing (PDF/image)",
    uploading: "Uploading…",
    upload: "Upload",
    uploaded: "Document uploaded",
    removed: "Document removed",
  },
  history: {
    title: "History",
    empty: "No history.",
  },
  issues: {
    title: "Issues",
    raise: "Raise issue",
    empty: "No issues raised.",
    resolve: "Resolve",
    save: "Save issue",
    severity: "Severity",
    whatsWrong: "What's wrong?",
    resolvedAt: "resolved {date}",
    raisedToast: "Issue raised",
    resolvedToast: "Issue resolved",
    status: {
      open: "Open",
      resolved: "Resolved",
    },
  },
  materials: {
    title: "Materials",
    add: "Add material",
    empty: "No material requirements.",
    addedToast: "Material added",
  },
  operations: {
    title: "Operations",
    add: "Add operation",
    operation: "Operation",
    empty: "No operations yet.",
    noWorkCenter: "No work centre",
    setup: "setup {minutes}m",
    run: "run {minutes}m/unit",
    addedToast: "Operation added",
  },
};
